import { render, staticRenderFns } from "./profilerReseller.vue?vue&type=template&id=6b6ddb9c&scoped=true"
import script from "./profilerReseller.vue?vue&type=script&lang=js"
export * from "./profilerReseller.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6ddb9c",
  null
  
)

export default component.exports